// Angular Core Modules
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

// Lib Modules
import { MaterialModule } from "../material-module/material.module";

// Components
import { ButtonComponent } from "./components/buttons/button/button.component";
import { FormElementsComponent } from "./components/forms/form-elements/form-elements.component";
import { IconComponent } from "./components/icons/icon/icon.component";
import { CheckboxComponent } from "./components/inputs/checkbox/checkbox.component";
import { RadioButtonComponent } from "./components/inputs/radio-button/radio-button.component";
import { SelectComponent } from "./components/inputs/select/select.component";
import { TextBoxComponent } from "./components/inputs/text-box/text-box.component";
import { TextareaComponent } from "./components/inputs/textarea/textarea.component";
import { LabelComponent } from "./components/labels/label/label.component";
import { ModalBackgroundComponent } from "./components/modals/modal-background/modal-background.component";
import { TypographyElementsComponent } from "./components/typography/typography-elements/typography-elements.component";
import { AddressBarComponent } from "./components/bars/address-bar/address-bar.component";
import { DodoMatImageButtonComponent } from "./components/buttons/dodo-mat-image-button/dodo-mat-image-button.component";
import { AddressAutoCompleteComponent } from "./components/auto-completes/address-auto-complete/address-auto-complete.component";
import { DodoMatComponentsModule } from "../dodo-mat-components/dodo-mat-components.module";
import { TealiumModule } from "../../tealium/tealium.module";
// import {
// 	SwiperModule,
// 	SwiperConfigInterface,
// 	SWIPER_CONFIG,
// } from "@sonrisa-dev/ngx-swiper-wrapper-sonfork";
import { DropSelectComponent } from "./components/drop-downs/drop-select/drop-select.component";
import { MiniDropSelectComponent } from "./components/drop-downs/mini-drop-select/mini-drop-select.component";
import { MeasurementInputComponent } from "./components/inputs/measurement-input/measurement-input.component";
import { SecondaryButtonComponent } from "./components/buttons/secondary-button/secondary-button.component";

export const components = [
	AddressBarComponent,
	ButtonComponent,
	SecondaryButtonComponent,
	FormElementsComponent,
	IconComponent,
	CheckboxComponent,
	RadioButtonComponent,
	SelectComponent,
	TextBoxComponent,
	TextareaComponent,
	LabelComponent,
	ModalBackgroundComponent,
	TypographyElementsComponent,
	DodoMatImageButtonComponent,
	AddressAutoCompleteComponent,
	DropSelectComponent,
	MiniDropSelectComponent,
	MeasurementInputComponent,
];

// const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
// 	observer: true,
// 	direction: "horizontal",
// 	threshold: 50,
// 	slidesPerView: 2,
// 	keyboard: true,
// 	mousewheel: true,
// 	scrollbar: true,
// 	navigation: true,
// 	pagination: true,
// 	spaceBetween: 5,
// };

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		DodoMatComponentsModule,
		MaterialModule,
		TealiumModule,
		// SwiperModule,
	],
	declarations: [...components],
	exports: [...components],
	providers: [
		// {
		// 	provide: SWIPER_CONFIG,
		// 	useValue: DEFAULT_SWIPER_CONFIG,
		// },
	],
})
export class DodoComponentsCommonModule {}
